import { AxiosResponse } from 'axios';
import { ErrorHandler } from '@/store/models/VuexRequestModels/ErrorHandlerModel';
import { HandleError } from './ErrorHelper';
import { FinallyHandler } from '@/store/models/VuexRequestModels/FinallyHandlerModel';

export function handleResponse(response: AxiosResponse) {
  if (response.status === 401) {
    localStorage.removeItem('user');
    document.location.reload(true);
  }
}
export function handleErrorResponse(error: any) {
  if (error.response.status === 401) {
    localStorage.removeItem('user');
    document.location.reload(true);
  }
}

export function VuexRequest(
  request = async () => {},
  errorHandler: ErrorHandler = { ErrorMsg: '', ErrorHandler: null },
  finallyHandler: FinallyHandler = { finally: () => {} }
): Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      await request();
      resolve();
    } catch (err) {
      console.log(err);
      const { ErrorMsg, ErrorHandler } = errorHandler;
      HandleError(ErrorMsg, ErrorHandler);
    } finally {
      if (finallyHandler.finally) {
        finallyHandler.finally();
      }
    }
  });
}

export function downloadFile(data: string, fileName: string) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  // window.open(url, '_blank');
}
